import PositionedSnackbar from "app/shared/ui/SnackBar/SnackBar";

export const ShowSnackBar = (props) => {
  return <PositionedSnackbar message={props.message} autoHideDuration={3000} />;
};
